var _effectorFileName = "/builds/gmini/front-common/src/auth/auth.ts";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { createStore, createEvent, combine, merge } from 'effector';
import { useStoreMap, useStore } from 'effector-react';
import { useSnackbar } from 'notistack';
import * as Sentry from '@sentry/browser';
import * as React from 'react';
import jwtDecode from 'jwt-decode';
import { isString, FetchService, FetchServiceEvent, isNumber } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
var resetToken = createEvent({
  name: "resetToken",
  sid: "h8eu86"
}); //TODO вынести в подписку с переменной

export var refreshTimeoutIdx$ = createStore(null, {
  name: "refreshTimeoutIdx$",
  sid: "th4z9k"
}).on(merge([api.Auth.login.doneData, api.Auth.refresh.doneData], {
  name: "refreshTimeoutIdx$",
  sid: "q6oxj3"
}), function (timeoutIdx, _ref) {
  var accessTokenExpiresIn = _ref.accessTokenExpiresIn;
  var expireTime = accessTokenExpiresIn * 1000;

  if (timeoutIdx) {
    clearTimeout(timeoutIdx);
  }

  if (isNumber(expireTime)) {
    var tokenExpire = setTimeout(function () {
      return api.Auth.refresh.defaultContext(undefined);
    }, expireTime);
    return tokenExpire;
  }

  return null;
}).on(api.Auth.logout.doneData, function (timeoutIdx) {
  if (timeoutIdx) {
    clearTimeout(timeoutIdx);
  }

  return null;
});
export var authPending$ = combine({
  ɔ: [[api.Auth.login.defaultContext.pending$, api.Auth.refresh.defaultContext.pending$, api.Auth.User.fetch.defaultContext.pending$], function (pending) {
    return pending.some(Boolean);
  }],
  config: {
    name: "authPending$",
    sid: "-t3koq0"
  }
});
export var initPending$ = createStore(true, {
  name: "initPending$",
  sid: "12d1xu"
}).on(authPending$.updates, function (state, value) {
  if (!value) {
    return value;
  }

  return state;
});
export var accessToken$ = createStore(null, {
  name: "accessToken$",
  sid: "gu9k74"
}).on(api.Auth.login.doneData, function (_, _ref2) {
  var accessToken = _ref2.accessToken;
  document.cookie = 'refreshToken=eyJhbGciOiJIUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICIyYzQxNDVjOS1mM2UxLTQ3NjItYjJkYS1hMDAzNzFiODA4MTEifQ.eyJleHAiOjE2MjM5MTAyMDAsImlhdCI6MTYyMzkwODQwMCwianRpIjoiZjM3MmJkMTUtNGY2Ny00YzFkLWFlZDQtOWMyMDAwNWIyYjk3IiwiaXNzIjoiaHR0cHM6Ly9rZXljbG9hay5kZXYuZ21pbmkudGVjaC9hdXRoL3JlYWxtcy9nbWluaSIsImF1ZCI6Imh0dHBzOi8va2V5Y2xvYWsuZGV2LmdtaW5pLnRlY2gvYXV0aC9yZWFsbXMvZ21pbmkiLCJzdWIiOiJhNmM3ZGQ4MC03OWJkLTQyNzQtOGNhZi05ODg5YWRhM2I4ZWIiLCJ0eXAiOiJSZWZyZXNoIiwiYXpwIjoiZ21pbmlfY29tbW9uIiwic2Vzc2lvbl9zdGF0ZSI6IjU0ZjY1ZTJkLWZkNGQtNGZjNy1hODdhLTg1MGIyNzkzZDVmZiIsImF1dGhvcml6YXRpb24iOnsicGVybWlzc2lvbnMiOlt7InNjb3BlcyI6WyJWaWV3IG93biIsIkVkaXQgZm9yZWlnbiIsIlZpZXcgZm9yZWlnbiIsIkVkaXQgb3duIl0sInJzaWQiOiI1ZjY4ZGExMC0wY2Q4LTQ4ZGYtYmYyZS05OTI4MTBkYWM1M2IiLCJyc25hbWUiOiJDbGFzc2lmaWVyIGRldiJ9LHsic2NvcGVzIjpbIlZpZXcgb3duIiwiRWRpdCBmb3JlaWduIiwiVmlldyBmb3JlaWduIiwiRWRpdCBvd24iXSwicnNpZCI6IjlmNjE5ZWU4LTRhMGYtNDEwZi1iZWNjLTA4OGYzMjM1ZWFiYSIsInJzbmFtZSI6IkNoZWNrdXAgZGV2In0seyJzY29wZXMiOlsiVmlldyBvd24iLCJFZGl0IGZvcmVpZ24iLCJWaWV3IGZvcmVpZ24iLCJFZGl0IG93biJdLCJyc2lkIjoiNTkyNTM1OTAtNjlmMC00MmZhLWFlYmItMjg4MTNmNjAzNGViIiwicnNuYW1lIjoiRXN0aW1hdGlvbiBkZXYifSx7InNjb3BlcyI6WyJWaWV3IG93biIsIkVkaXQgZm9yZWlnbiIsIlZpZXcgZm9yZWlnbiIsIkVkaXQgb3duIl0sInJzaWQiOiI1ZDk0N2E5Yy1lOTBjLTQ0YjItODUzYy0xNWJiMzEzMTZjMGEiLCJyc25hbWUiOiJGb2xkZXIgZGV2In1dfSwic2NvcGUiOiJvcGVuaWQgZW1haWwgcHJvZmlsZSJ9.6XI8Hyhfo0eQE5cXenWhWjZC_QUMMmAYmk2-QmszjH0';
  return accessToken;
}).on(api.Auth.refresh.doneData, function (_, res) {
  return res ? res.accessToken : res;
}).on(api.Auth.logout.doneData, function () {
  return null;
}).on(api.Auth.logout.fail, function () {
  return null;
}).reset(resetToken);
export var authInfo$ = accessToken$.map(parseJWT);
authInfo$.watch(function (info) {
  if (info) {
    api.Auth.User.fetch.defaultContext(undefined);
  }
});
export var userInfo$ = createStore(null, {
  name: "userInfo$",
  sid: "mcab8r"
}).on(api.Auth.User.fetch.defaultContext.doneData, function (_, userData) {
  return userData;
});
userInfo$.watch(function (info) {
  Sentry.setUser(info ? {
    id: info.id,
    email: info.email || undefined,
    username: info.name
  } : null);
});

function parseJWT(token) {
  if (!token) {
    return null;
  }

  var decodedToken = jwtDecode(token);
  return decodedToken;
}

export function useToken() {
  return useStoreMap({
    store: accessToken$,
    keys: [],
    fn: function fn(accessToken) {
      return isString(accessToken) ? accessToken : null;
    }
  });
}
export function useUnauthenticatedNotification(message) {
  var _useSnackbar = useSnackbar(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var authStatus = useStore(authInfo$) || null;
  React.useEffect(function () {
    if (!authStatus) {
      return;
    }

    function listener() {
      api.Auth.logout.defaultContext.submit();
      enqueueSnackbar(message, {
        variant: 'error'
      });
    }

    FetchService.globalEvents.on(FetchServiceEvent.unauthorized, listener);
    return function () {
      FetchService.globalEvents.off(FetchServiceEvent.unauthorized, listener);
    };
  }, [authStatus, enqueueSnackbar, message]);
}
export function setAuthHeader(arr, token) {
  arr.forEach(function (item) {
    return item.setAdditionalHeader('Authorization', "Bearer ".concat(token));
  });
}
export function removeAuthHeader(arr) {
  arr.forEach(function (item) {
    return item.removeAdditionalHeader('Authorization');
  });
} // 1. Запросить login с credentials, получаем accessToken OK
// 2. Пишем accessToken в стор OK
// 3. Распарсили токен и записали в стор информацию о юзере OK(парсим когда будет бэк)
// 4. Ставим таймер на время iat токена и делаем тихий refresh OK
// 5. При вызове любого эндпоинта доставать из стора accessToken$ токен и вставлять в хедер OK
// 6. При ответе любого эндпоинта 401 статусом: в рамках запроса вызывать эндпоинт refresh-token и при успешном ответе - повторять основной запрос